import {
  achievements_returned,
  achievement_earned,
  earned_achievements_returned,
  user_signed_out,
  user_profile_opened
} from '../actions/types';

const INITIAL_STATE = {
  achievements: [],
  earnedAchievements: [],
  newEarnedAchievement: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case user_profile_opened:
      return { ...state, earnedAchievements: [] };

    case achievements_returned:
      return { ...state, achievements: action.payload };

    case achievement_earned:
      return { ...state, newEarnedAchievement: action.payload };

    case earned_achievements_returned:
      return { ...state, earnedAchievements: action.payload };

    case user_signed_out:
      return { ...INITIAL_STATE, loaded: true };

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/AchievementsReducer.js